module.exports = __webpack_public_path__ + "img/hexagon.eb50e58d.svg";